import React from 'react';
import './svg.css';

const BlueRightArrow = () => {
  return (

    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
      <path d="M14.2502 6.81246L1.5 6.81246M14.2502 6.81246L8.93759 1.5M14.2502 6.81246L8.93759 12.1251" stroke="#00B0CA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  );
};

export default BlueRightArrow;